"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.populateResultsFundTable = exports.generateTableRow = exports.filterETFs = exports.fetchData = void 0;
var config_1 = require("./config");
var lang = document.documentElement.lang.toLowerCase().indexOf("en") > -1 ? "en" : "fr";
var ASSET_CLASS_JSON_KEYS = (_a = {},
    _a[i18n("Equity")] = "equity",
    _a[i18n("Fixed Income")] = "fixedIncome",
    _a[i18n("Balanced")] = "balanced",
    _a[i18n("Commodity")] = "commodity",
    _a[i18n("All")] = "all",
    _a);
var ASSET_CLASS_IMAGE_NAMES = (_b = {},
    _b[i18n("Equity")] = "Equity",
    _b[i18n("Fixed Income")] = "Fixed-Income",
    _b[i18n("Balanced")] = "Balanced",
    _b[i18n("Commodity")] = "Commodity",
    _b[i18n("All")] = "All",
    _b);
var REGION_IMAGE_NAMES = (_c = {},
    _c[i18n("Canada")] = "Canada",
    _c[i18n("USA")] = "USA",
    _c[i18n("Global")] = "Global",
    _c[i18n("Emerging Markets")] = "Emerging-Markets",
    _c[i18n("NA")] = "NA",
    _c);
var loadedData = null;
/**
 * Returns the entire dataset to be used in filtering process
 * @returns
 */
function fetchData() {
    if (loadedData)
        return Promise.resolve(loadedData);
    return fetch("../common/data/etfs-data-".concat(lang, ".json"))
        .then(function (res) { return res.json(); })
        .then(function (data) {
        loadedData = data;
        return data;
    });
}
exports.fetchData = fetchData;
/**
 * Used to go filter through full list of ETFs and spits out the funds that match the filters.
 * @param funds  - full ETF fund list
 * @param options - filterOptions used for filt
 * @returns
 */
function filterETFs(funds, options) {
    var filteredFunds = [];
    options.assetClass.forEach(function (assetClass) {
        var assetClassJSONKey = ASSET_CLASS_JSON_KEYS[assetClass];
        var fundData = funds[assetClassJSONKey];
        var equityStrategyArr = options.equityStrategy;
        var fixedIncomeStrategyArr = options.fixedIncomeStrategy;
        var balancedStrategyArr = options.balancedStrategy;
        var optionsRegionArr = options.region;
        var currencyArr = options.currency;
        if (assetClass === config_1.filterStringObj.assetClass.equity) {
            filteredFunds = __spreadArray(__spreadArray([], filteredFunds, true), filterFunds(fundData, equityStrategyArr, optionsRegionArr, currencyArr), true);
        }
        else if (assetClass === config_1.filterStringObj.assetClass.balanced) {
            filteredFunds = __spreadArray(__spreadArray([], filteredFunds, true), filterFunds(fundData, balancedStrategyArr, optionsRegionArr, currencyArr), true);
        }
        else if (assetClass === config_1.filterStringObj.assetClass.fixedIncome) {
            filteredFunds = __spreadArray(__spreadArray([], filteredFunds, true), filterFunds(fundData, fixedIncomeStrategyArr, optionsRegionArr, currencyArr), true);
        }
        else if (assetClass === config_1.filterStringObj.assetClass.commodity) {
            filteredFunds = __spreadArray(__spreadArray([], filteredFunds, true), filterFunds(fundData, [], optionsRegionArr, currencyArr), true);
        }
        else {
            filteredFunds = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], filteredFunds, true), filterFunds(funds["equity"], equityStrategyArr, optionsRegionArr, currencyArr), true), filterFunds(funds["balanced"], balancedStrategyArr, optionsRegionArr, currencyArr), true), filterFunds(funds["fixedIncome"], fixedIncomeStrategyArr, optionsRegionArr, currencyArr), true), filterFunds(funds["commodity"], [], optionsRegionArr, currencyArr), true);
        }
    });
    /**
     * Series of filter methods used on the fund data to be pushed into the filterFunds array
     * @param fundData - all the fund data based on the asset class
     * @param strategy - the asset class strategy array specific to the asset class
     * @param region - the region array holding all selected region
     * @returns
     */
    function filterFunds(fundData, strategy, region, currency) {
        var filtered;
        if (strategy.length === 0 && region.length === 0) {
            // if no strategy and no region filters selected, spit out entire fund list based off of asset class.
            if (currency.length !== 0) {
                filtered = fundData.filter(function (fundElem) {
                    return currency.indexOf(fundElem.currency) > -1;
                });
            }
            else {
                filtered = fundData;
            }
        }
        else if (strategy.length === 0 && region.length !== 0) {
            // if no strategy but there are region filters selected, filter only based off region.
            if (currency.length !== 0) {
                filtered = fundData
                    .filter(function (fundElem) {
                    return currency.indexOf(fundElem.currency) > -1;
                })
                    .filter(function (fundElem) {
                    return region.indexOf(fundElem.region) > -1;
                });
            }
            else {
                filtered = fundData.filter(function (fundElem) {
                    return region.indexOf(fundElem.region) > -1;
                });
            }
        }
        else if (strategy.length !== 0 && region.length === 0) {
            // if no region but there are strategy filters selected, filter only based off strategy.
            if (currency.length !== 0) {
                filtered = fundData
                    .filter(function (fundElem) {
                    return currency.indexOf(fundElem.currency) > -1;
                })
                    .filter(function (fundElem) {
                    return "strategy" in fundElem && strategy.indexOf(fundElem.strategy) > -1;
                });
            }
            else {
                filtered = fundData.filter(function (fundElem) {
                    return "strategy" in fundElem && strategy.indexOf(fundElem.strategy) > -1;
                });
            }
        }
        else {
            // any other situation, filter from both region and strategy
            if (currency.length !== 0) {
                filtered = fundData
                    .filter(function (filteredFundElem) {
                    return region.indexOf(filteredFundElem.region) > -1;
                })
                    .filter(function (fundElem) {
                    return "strategy" in fundElem && strategy.indexOf(fundElem.strategy) > -1;
                })
                    .filter(function (fundElem) {
                    return currency.indexOf(fundElem.currency) > -1;
                });
            }
            else {
                filtered = fundData
                    .filter(function (filteredFundElem) {
                    return region.indexOf(filteredFundElem.region) > -1;
                })
                    .filter(function (fundElem) {
                    return "strategy" in fundElem && strategy.indexOf(fundElem.strategy) > -1;
                });
            }
        }
        return filtered;
    }
    return filteredFunds;
}
exports.filterETFs = filterETFs;
function generateTableRow(fund, commodityOnly) {
    var fundSymbol = fund.symbol;
    var fundName = fund.name;
    var fundAssetClass = fund.assetClass;
    var fundAssetClassImage = ASSET_CLASS_IMAGE_NAMES[fundAssetClass];
    var fundCurrency = fund.currency;
    var fundRegion = fund.region;
    var fundRegionImage = REGION_IMAGE_NAMES[fundRegion];
    var fundURL = fund.url;
    var el = document.createElement("tr");
    if (commodityOnly) {
        el.innerHTML = "\n        <td class=\"symbol\"></td>\n        <td class=\"asset-name\"></td>\n        <td class=\"asset-class\">\n            <img src=\"\" class=\"table-icon\" alt=\"\">\n            <span></span>\n        </td>\n        <td class=\"currency\"></td>";
    }
    else {
        el.innerHTML = "\n        <td class=\"symbol\"></td>\n        <td class=\"asset-name\"></td>\n        <td class=\"asset-class\">\n            <img src=\"\" class=\"table-icon\" alt=\"\">\n            <span></span>\n        </td>\n        <td class=\"currency\"></td>\n        <td class=\"region\">\n        </td>";
    }
    el.classList.add("fund-row");
    el.querySelector(".symbol").textContent = fundSymbol;
    el.querySelector(".asset-name").textContent = fundName;
    el.querySelector(".asset-class img").src = "../common/images/".concat(fundAssetClassImage
        .split(" ")
        .map(function (part) { return "".concat(part[0].toUpperCase()).concat(part.substring(1)); })
        .join("-"), ".svg");
    el.querySelector(".asset-class span").textContent = fundAssetClass;
    el.querySelector(".currency").textContent = "".concat(fundCurrency);
    if (!commodityOnly) {
        if (fundAssetClass != i18n("Commodity")) {
            var regionImage = document.createElement("img");
            regionImage.src = "../common/images/".concat(fundRegionImage
                .split(" ")
                .map(function (part) { return "".concat(part[0].toUpperCase()).concat(part.substring(1)); })
                .join("-"), ".svg");
            regionImage.alt = fundRegion;
            regionImage.classList.add("table-icon");
            el.querySelector(".region").appendChild(regionImage);
        }
        else {
            // const regionNA = document.createElement("p");
            // regionNA.innerText = i18n("N/A");
            el.querySelector(".region").innerText = i18n("N/A");
        }
    }
    el.setAttribute("data-url", fundURL);
    return el;
}
exports.generateTableRow = generateTableRow;
/**
 * Used to populate the fund table on the results page based on filters.
 * @param filteredArrayOfFunds - filtered list of funds.
 * @returns - promise to open accordion and anything else after table is already drawn
 */
function populateResultsFundTable(filteredArrayOfFunds, commodityOnly) {
    return new Promise(function (resolve) {
        var tableBodyHTMLElement = document.getElementById("fund-table-body");
        tableBodyHTMLElement.innerHTML = "";
        // disables display of "Region" column if only Commodities are being shown
        if (commodityOnly) {
            document.getElementById("table-header-region").style.display = "none";
        }
        else {
            document.getElementById("table-header-region").style.display = "table-cell";
        }
        filteredArrayOfFunds.forEach(function (fund) { return tableBodyHTMLElement.appendChild(generateTableRow(fund, commodityOnly)); });
        resolve(true);
    });
}
exports.populateResultsFundTable = populateResultsFundTable;
//# sourceMappingURL=module.js.map